var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M.974 1.5h16v1h-16zm0 6h16v1h-16zm16 6h-16v1h16z",
  clipRule: "evenodd"
})));
export { SvgBurger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuOTczOTk5IDEuNUgxNi45NzRWMi41SDAuOTczOTk5VjEuNVpNMC45NzM5OTkgNy41SDE2Ljk3NFY4LjVIMC45NzM5OTlWNy41Wk0xNi45NzQgMTMuNUgwLjk3Mzk5OVYxNC41SDE2Ljk3NFYxMy41WiIgZmlsbD0iIzFDMUMxQSIvPgo8L3N2Zz4K";